export default __webpack_public_path__ + "static/media/bird_white_male.269658c4.png";